import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromChangeInfo from './reducers/change-info.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ChangeInfoEffects } from './effects/change-info.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('changeInfo', fromChangeInfo.reducer),
    EffectsModule.forFeature([ChangeInfoEffects])
  ]
})
export class ChangeInfoModule { }
